// src/utils/shopUtils.js
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { playSound } from '../utils/soundPlayer';
import { logFinancialEvent, logUserAction, EVENT_TYPES } from '../utils/securityLogger';

async function waitForAuth() {
  const auth = getAuth();
  if (auth.currentUser) return;
  await new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
}

export const handleBuy = async (item, userId, quantity, onComplete, collectionName = "shopItems-v2") => {
  try {
    await waitForAuth();
    const auth = getAuth();
    const user = auth.currentUser;
    
    console.log('Auth state:', { user: !!user, uid: user?.uid });
    
    if (!user) {
      alert('Please log in again to complete the purchase.');
      return;
    }
    
    // Force fresh token to avoid 401 errors
    const token = await user.getIdToken(true);
    console.log('Token obtained:', !!token);

    if (!item?.id) {
      alert('Invalid item.');
      return;
    }

    // Log purchase initiation
    await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_INITIATED, user.uid, item.priceDP * quantity, {
      itemId: item.id,
      itemName: item.name,
      quantity: quantity,
      totalCost: item.priceDP * quantity,
      collectionName: collectionName,
      purchaseMethod: 'shop'
    });

    // Call the function as HTTP request
    const response = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/purchaseItem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        itemId: item.id,
        quantity: Number(quantity || 1),
        collectionName
      })
    });

    const res = await response.json();
    
    if (!response.ok) {
      // Log failed purchase
      await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_FAILED, user.uid, item.priceDP * quantity, {
        itemId: item.id,
        itemName: item.name,
        quantity: quantity,
        totalCost: item.priceDP * quantity,
        error: res.error || 'Purchase failed',
        statusCode: response.status
      });
      throw new Error(res.error || 'Purchase failed');
    }

    if (!res?.success) {
      // Log failed purchase
      await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_FAILED, user.uid, item.priceDP * quantity, {
        itemId: item.id,
        itemName: item.name,
        quantity: quantity,
        totalCost: item.priceDP * quantity,
        error: res?.error || 'Purchase failed'
      });
      throw new Error(res?.error || 'Purchase failed');
    }

    // Log successful purchase
    await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_SUCCESS, user.uid, item.priceDP * quantity, {
      itemId: item.id,
      itemName: item.name,
      quantity: quantity,
      totalCost: item.priceDP * quantity,
      collectionName: collectionName,
      purchaseMethod: 'shop',
      transactionId: res.transactionId || 'N/A'
    });

    // Log user action
    await logUserAction('SHOP_PURCHASE', user.uid, {
      itemId: item.id,
      itemName: item.name,
      quantity: quantity,
      totalCost: item.priceDP * quantity,
      collectionName: collectionName
    });

    playSound('purchase');
    if (typeof onComplete === 'function') onComplete();
  } catch (error) {
    console.error('❌ Purchase error:', error?.message || error);
    alert('An error occurred: ' + (error?.message || 'Unknown error'));
  }
};